import BajaService from "@/api/services/personal/nomencladores/BajaService"
import Vue from "vue"

const state = () => ({
    bajas: [],
    pagination: {
        descending: false,
        page: 1,
        rowsPerPage: 10,
        sortBy: "descripcion",
        rowsPerPageItems: [5, 10, 20, 30, 40, 50]
    }
})

const getters = {
    BAJAS: state => {
        return state.titulos
    },
    BAJAS_PAG: state => {
        return state.pagination
    }
}

const mutations = {
    SET_BAJAS: (state, payload) => {
        state.titulos = payload
    },

    SET_BAJAS_PAG: (state, payload) => {
        state.pagination = payload
    },

    ADD_BAJA: (state, payload) => {
        state.titulos.push(payload)
    },

    UPDATE_BAJA: (state, payload) => {
        state.bajas = state.bajas.map(el => (el.id === payload.id ? payload : el))
    },

    DELETE_BAJA: (state, payload) => {
        state.bajas = state.bajas.filter(el => el.id !== payload.id)
    }
}

const actions = {
    LOAD_BAJAS: async ({ commit, state }, { filter, bajaEstado }) => {
        try {
            let pagination = {
                page: state.pagination.page,
                rowsPerPage: state.pagination.rowsPerPage,
                sortBy: state.pagination.descending ? "-" + state.pagination.sortBy : state.pagination.sortBy
            }
            let { data, status, headers } = await BajaService.get({ filter, bajaEstado, ...pagination })
            if (status === 200) {
                commit("SET_BAJAS", data)
                return parseInt(headers["x-pagination-total-count"])
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se han podido cargar los motivos bajas, inténtelo nuevamente"
            })
        }
    },

    LOAD_ALL_BAJAS: async ({ commit }) => {
        try {
            let { data, status } = await BajaService.getAll()
            if (status === 200) {
                commit("SET_BAJAS", data)
                return data
            }
        } catch (error) {
            if (error.response) {
                return { data: error.response.data, status: error.response.status }
            }
        }
    },

    LOAD_ALL_RECORDS_BAJAS: async ({ commit }) => {
        try {
            let { data, status } = await BajaService.getAllRecords()
            if (status === 200) {
                commit("SET_BAJAS", data)
                return null
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se ha podido cargar los motivos Baja, inténtelo nuevamente"
            })
        }
    },

    LOAD_HISTORY_BAJA: async ({ commit }, payload) => {
        try {
            let { data, status } = await BajaService.getHistory(payload)
            if (status === 200) {
                commit("UPDATE_BAJA", data)
            }
            return null
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se ha podido cargar el historial del motivo baja, inténtelo nuevamente"
            })
        }
    },

    ADD_BAJA: async ({ commit }, payload) => {
        try {
            let { data, status } = await BajaService.post(payload)
            if (status === 201) {
                commit("ADD_BAJA", data)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Agregando",
                    text: "El motivo de la baja ha sido agregado satisfactoriamente"
                })
            }
            return null
        } catch (error) {
            if (!error.response) {
                Vue.notify({
                    group: "pages",
                    type: "error",
                    title: "Servidor",
                    text: "No se ha podido agregar el motivo de la baja, inténtelo nuevamente"
                })
            } else {
                return { data: error.response.data, status: error.response.status }
            }
        }
    },

    UPDATE_BAJA: async ({ commit }, payload) => {
        try {
            let { data, status } = await BajaService.put(payload)
            if (status === 200) {
                commit("UPDATE_BAJA", data)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Modificando",
                    text: "El motivo de la baja ha sido modificado satisfactoriamente"
                })
            }
            return null
        } catch (error) {
            if (!error.response) {
                Vue.notify({
                    group: "pages",
                    type: "error",
                    title: "Servidor",
                    text: "No se ha podido modificar el motivo de la baja, inténtelo nuevamente"
                })
            } else {
                return { data: error.response.data, status: error.response.status }
            }
        }
    },

    DELETE_BAJA: async ({ commit }, payload) => {
        try {
            let { status, data } = await BajaService.delete(payload)
            if (status === 204) {
                commit("DELETE_BAJA", payload)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Eliminando",
                    text: "El motivo de la baja ha sido eliminado satisfactoriamente"
                })
            }
            if (status === 200) {
                commit("UPDATE_BAJA", data)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Deshabilitando",
                    text: "El motivo de la baja ha sido deshabilitado satisfactoriamente"
                })
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se ha podido eliminar/deshabilitar el historial del motivo baja, inténtelo nuevamente"
            })
        }
    }
}

export default {
    state,
    getters,
    mutations,
    actions
}
